import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextFormatStrikethrough20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTextFormatStrikethrough20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 3H17v3.367a.75.75 0 0 1-1.5 0V4.5H11v2.958a.75.75 0 0 1-1.5 0V4.5H5v1.867a.75.75 0 0 1-1.5 0zM11 14.002a.75.75 0 0 0-1.5 0V15.5H7.75a.75.75 0 0 0 0 1.5h4.999a.75.75 0 0 0 0-1.5H11zM4.5 9.98a.75.75 0 0 0 0 1.5H16a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextFormatStrikethrough20);
